// Function to consolidate address fields (Define this outside the CardInfo component or import it)
export const getConsolidatedAddress = (vendor) => {
    if (!vendor) return "Address N/A";
    
    // Check nested locality/city as well, as per your data structure
    const homeLocality = vendor.address?.homeAddress?.locality;
    const officeLocality = vendor.address?.officeAddress?.locality;
    
    // We assume the flatVendor structure is not available here, 
    // so we rely on the full vendor object passed to CardInfo.
    
    // Prioritize locality from nested addresses or the top-level full_address from office.
    const primaryAddress = homeLocality || officeLocality || vendor.address?.officeAddress?.full_address || vendor.full_address;
    
    // If the primary address is a full street address, use it. Otherwise, consolidate.
    if (primaryAddress && primaryAddress.includes(',')) {
        // If it looks like a full address already, use the first part as a short locality.
        return primaryAddress.split(',')[0].trim(); 
    }
    
    // Fallback: Use city and state if they exist (This logic is for the SHORT address)
    const parts = [
        primaryAddress,
        vendor.address?.officeAddress?.city,
        vendor.address?.officeAddress?.state
    ].filter(Boolean);
    
    // Use a Set to ensure unique parts (for cases where locality == city)
    const uniqueParts = Array.from(new Set(parts.map(p => p.trim())));

    return uniqueParts.slice(0, 2).join(", ") || "Location Details N/A";
};

// Function to return the FULL address for hover
export const getFullAddress = (vendor) => {
    if (!vendor) return "Address N/A";
    
    const officeAddress = vendor.address?.officeAddress;
     const homeAddress = vendor.address?.homeAddress;
    const addressComponents = [
        officeAddress?.full_address||homeAddress?.full_address,
        officeAddress?.locality|| homeAddress?.locality,
        officeAddress?.city|| homeAddress?.city,
        officeAddress?.state||homeAddress?.state,
        officeAddress?.pincode||homeAddress?.pincode,
    ];
    
    // Filter out null/undefined/empty strings and join them.
    const uniqueParts = Array.from(new Set(addressComponents.filter(Boolean).map(p => p.trim())));
    
    return uniqueParts.join(", ") || "Full Address N/A";
};